import { createSelector } from "reselect";
import { getBillingRunDocumentAttachmentIds } from "./root";

export const selectRelatedAttachmentIdsByBillingDocumentIdLookup =
  createSelector(
    getBillingRunDocumentAttachmentIds,
    billingRunDocumentAttachmentsByIdLookup =>
      Object.fromEntries(
        Object.entries(billingRunDocumentAttachmentsByIdLookup).map(
          ([documentId, data]) => [documentId, data.attachmentIds || []],
        ),
      ),
  );
